<template>
  <div>
    <el-table :data="list.value" border style="width: 100%">
      <el-table-column prop="channelId" label="渠道">
        <template slot-scope="scope">
          <span>{{ `[${scope.row.channelId}] ` }} {{ scope.row.channelName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="clientType" label="端类型">
        <!-- 1-发端 2-收端 -->
        <template slot-scope="scope">
          <span v-if="scope.row.clientType == '1'">发端</span>
          <span v-if="scope.row.clientType == '2'">收端</span>
        </template>
      </el-table-column>
      <el-table-column prop="label" label="标签">
        <template slot-scope="scope">
          <!-- 1-白名单 2-灰名单 3-黑名单 -->
          <span v-if="scope.row.label == 1">白名单</span>
          <span v-if="scope.row.label == 2">灰名单</span>
          <span v-if="scope.row.label == 3">黑名单</span>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="创建人"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="updateBy" label="修改人"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button v-auth="'SECURITY_MANAGE_CHANNEL_MANAGE_EDIT'" type="text" size="small"
            @click="edit(scope.row)">编辑</el-button>
          <el-button v-auth="'SECURITY_MANAGE_CHANNEL_MANAGE_DEL'" type="text" size="small"
            @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ElementPagination style="margin-bottom: 20px;" :total="searchParams.total" :current="searchParams.current"
      :size="searchParams.size" :pageSizes="[10, 20, 50, 100]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </ElementPagination>
    <Add ref="add" />
  </div>
</template>

<script>
import { deleteChannel } from '@/api/security/channelManage';
import ElementPagination from '@/components/ElementPagination';
import Message from '@/components/Message';
import Add from './add.vue';

export default {
  name: 'WebSaaSTable',

  inject: ['searchParams', 'list', 'loadList'],

  components: {
    ElementPagination,
    Add
  },

  data() {
    return {

    };
  },

  methods: {
    /** 删除 */
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await deleteChannel(id);
        console.log("🚀 ~ del ~ data:", data)
        if (data.code === 200) {
          Message.success('删除成功');
          this.loadList();
        }

      }).catch(() => {
        console.log('取消删除');
      });
    },
    /** 编辑的事件 */
    edit(row) {
      this.$refs.add.show(row, 'edit');
    },
    //^ ^--------------分页相关-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
